import { EventEmitter } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { LanguagePipe } from '../../services/language.pipe';
import { NotificationService } from '../../services/notification.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatService } from '../../services/chat.service';
import { BusinessEventService } from '../../services/business-event.service';
import { TurnService } from '../../services/turn.service';
var CallComponent = (function () {
    function CallComponent(_data, _lang, _blogic, _bevent, _notify, _turn, _chat) {
        this._data = _data;
        this._lang = _lang;
        this._blogic = _blogic;
        this._bevent = _bevent;
        this._notify = _notify;
        this._turn = _turn;
        this._chat = _chat;
        this.isCallLoading = new EventEmitter();
        this.enableRecallButton = false;
        this.enableCallButton = false;
        this.selectedDesk = null;
        this.socketRetries = 0;
        this.callLoading = false;
        this.destroy$ = new Subject();
    }
    CallComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._updateTurn(this._data.turn);
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._updateTurn(response);
        });
        this._selectedUpdateTurn(this._data.selectedTurn);
        this._data.selectedTurnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._selectedUpdateTurn(response);
        });
        this._isWaiting();
        this._turn.startDeskAutomations();
        if (this._data.inQueue != 0
            && this._data.configuration["getTurnToInit"]
            && !this._data.configuration["activeSupervisor"]
            && this._data.session["queuemode"] == 'Q') {
            this._turn.call();
        }
        this.initIoConnection();
    };
    CallComponent.prototype.ngOnDestroy = function () {
        this._turn.stopDeskAutomations();
        this.destroy$.next();
        this.destroy$.complete();
    };
    // Initialize SocketConnection
    CallComponent.prototype.initIoConnection = function () {
        var _this = this;
        if (this.socketRetries != null)
            this.socketRetries++;
        if (this.subscriptionClose != null)
            this.subscriptionClose.unsubscribe();
        if (this.subscriptionOpen != null)
            this.subscriptionOpen.unsubscribe();
        if (this.ioConnection != null)
            this.ioConnection.unsubscribe();
        this.ioConnection = this._bevent.onMessage()
            .subscribe(function (response) {
            if (response["eventhook"] == "viewerfb") {
                _this._data.turnStatusInViewer.unshift(response["message"]);
                _this._data.turnStatusInViewer = _this._data.turnStatusInViewer.slice(0, 100);
            }
            if (response["eventhook"] == "disconect") {
                _this._data.deskInUseDeskName = response["message"]["desk_name"];
                _this._data.deskInUseHostAddr = response["message"]["hostaddr"];
                _this._data.deskInUseOffice = response["message"]["office"];
                _this._data.deskInUseDate = response["message"]["logindate"];
                _this._data.deskInUseHour = response["message"]["logintime"];
                _this._data.deskInUse = true;
            }
            if (response["eventhook"] == "force_disconect") {
                _this.softLogout();
            }
            if (response["eventhook"] == "turninfo")
                _this.parseIsWaiting(response["message"]);
        });
        this.subscriptionOpen = this._bevent.onOpen()
            .subscribe(function (response) { });
        this.subscriptionClose = this._bevent.onClose()
            .subscribe(function (response) {
            _this.initIoConnection();
        });
    };
    CallComponent.prototype.actionCall = function (desk) {
        this._turn.actionCallList(desk);
    };
    /* When the turn information change */
    CallComponent.prototype._updateTurn = function (turn) {
        if (turn == null) {
            this.enableRecallButton = false;
        }
        else {
            this.enableRecallButton = true;
        }
    };
    /* When the turn information change */
    CallComponent.prototype._selectedUpdateTurn = function (selectedTurn) {
        if (selectedTurn != null && (selectedTurn["type"] == 'inWait' || selectedTurn["type"] == 'cancelled')) {
            this.enableCallButton = true;
        }
        else {
            this.enableCallButton = false;
        }
        if (selectedTurn != null
            && selectedTurn["type"] == 'inAttention'
            && this._data.configuration["activeSupervisor"]) {
            this._data.enableRecallSupervisor = true;
        }
        else {
            this._data.enableRecallSupervisor = false;
        }
    };
    /* Get the queue size */
    CallComponent.prototype._isWaiting = function () {
        var _this = this;
        this._blogic.turnIsWaiting()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.parseIsWaiting(response["message"]);
        });
    };
    CallComponent.prototype.parseIsWaiting = function (response) {
        var parse = response;
        var data = this._data.session;
        var candidate = 0;
        var item = (this._data.session["schema"] == 'Q') ? parse["qinfo"] : parse["kinfo"];
        // Calculate item with > size
        var filtered = [];
        data["schemaitms"].split(',').forEach(function (element) {
            var filter = item.filter(function (x) { return x.id == element; });
            if (filter)
                filtered.push(filter[0]);
        });
        filtered = filtered.filter(function (x) { return x != null; });
        candidate = filtered.reduce(function (a, b) { return a + (b['size'] || 0); }, 0);
        candidate = (candidate) ? candidate : 0;
        if (this._data.inQueue < candidate && this._notify.hasPermission() && this._data.turn == null) {
            this._notify.notify(this._lang.transform("notifyTitle"), this._lang.transform("notifyBody"));
        }
        this._data.inQueue = candidate;
    };
    CallComponent.prototype.showAlert = function (value) {
        this.subscriptionClose.unsubscribe();
        this.subscriptionOpen.unsubscribe();
        this.ioConnection.unsubscribe();
        this._bevent.close();
        this.socketRetries = null;
    };
    CallComponent.prototype.logout = function () {
        this._blogic
            .logout()
            .pipe(takeUntil(this.destroy$))
            .subscribe();
        this._data.deleteStoredCredentials();
        localStorage.removeItem("office");
        localStorage.removeItem("desk");
        window.location.reload();
    };
    CallComponent.prototype.softLogout = function () {
        if (this.subscriptionClose != null)
            this.subscriptionClose.unsubscribe();
        if (this.subscriptionOpen != null)
            this.subscriptionOpen.unsubscribe();
        if (this.ioConnection != null)
            this.ioConnection.unsubscribe();
        this._bevent.close();
        this._chat.close();
        this._data.timeExceed = true;
    };
    return CallComponent;
}());
export { CallComponent };
